const state = {
  elements : [] , 
  crntIdx : 0 , 
  accordionH : 0 , 
} ; 

const mutations = {
  elemSet ( state : any , { elements }) {
    const tmpArr:Object[] = [] ; 
    elements.map(( info : Object , idx : Number ) => {
      tmpArr[ tmpArr.length ] = {
        idx , 
        open: false , 
        scrH: 0 , 
      } ; 
    }) ; 
    state.elements = tmpArr ; 
  } , 
  setAttribute ( state : any , info : any ) {
    Object.assign( state , {
      ...state , 
      ...info , 
    }) ; 
  } , 
  showHideHandler ( state : any , { idx , info }) {
    let { crntIdx , elemNodes : { header , tagSrchInput , scrlHeader }} = info ; 
    let { open } = state.elements[ crntIdx ] ; 

    if ( open ) {
      const tagList:Object[] = [] ; 
      state.elements.map(( tagInfo : any , idx : Number ) => {
        if ( crntIdx == idx ) {
          tagInfo.open = false ; 
          tagInfo.gapH = 0 ; 
          tagInfo.scrH = 0 ; 
        }
        tagList[ tagList.length ] = { ...tagInfo } ; 
      }) ; 
  
      Object.assign( state , { elements : tagList }) ; 
      return ; 
    }

    let titleH = header.offsetHeight ; 
    let tagSrchH = tagSrchInput.offsetHeight ; 
    let scrlTitleH = scrlHeader.offsetHeight ; 
    let mT = parseFloat( getComputedStyle( header.parentElement , null )['marginTop'] ) ; 
    let tagListLen = state.elements.length; 
    let btmGap = 10; 
    let remainedH = state.accordionH - titleH * tagListLen - mT * tagListLen - btmGap ; 

    const tagList:Object[] = [] ; 
    state.elements.map(( tagInfo : Object , idx : Number ) => {
      // console.log( 'tagInfo : ' , Object.keys( tagInfo ) ) ; 
      // console.log( 'idx : ' , idx , 'crntIdx : ' , crntIdx ) ; 
      let open = ( crntIdx == idx ) ? true : false ; 
      let scrH = ( crntIdx == idx ) ? remainedH : 0 ; 
      let gapH = ( crntIdx == idx ) ? scrH - (scrH - tagSrchH - scrlTitleH) : 0 ; 

      Object.assign( tagInfo , { ...tagInfo , open , scrH , gapH }) ; 
      tagList[ tagList.length ] = { ...tagInfo , open , scrH , gapH } ; 
    }) ; 

    Object.assign( state , { crntIdx : idx , elements : tagList }) ; 
  }
} ; 

const actions = {} ; 

const getters = {
  elements ( state : any ) {
    return state.elements ; 
  } , 
  accordionH ( state : any ) {
    return state.accordionH ; 
  } , 
} ; 

export default {
  namespaced: true,
  state ,
  mutations , 
  actions , 
  getters 
} ; 